import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ShieldCheck, ArrowRight, Diamond } from "lucide-react";
import { toast } from "sonner";
import { authApi, apiError, isAdmin, isStaffOrAdmin, isStaff, logout } from "../../lib/api";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await authApi.login(email, password);
      if (!isStaffOrAdmin()) {
        logout();
        toast.error("Esta cuenta no tiene permisos de administrador ni de staff.");
        return;
      }
      if (isStaff() && !isAdmin()) {
        toast.success("¡Bienvenido al panel de atención Supera!");
        navigate("/admin/chat");
        return;
      }
      toast.success("¡Bienvenido, Super Admin!");
      navigate("/admin/dashboard");
    } catch (err) {
      toast.error(apiError(err, "Credenciales incorrectas."));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-navy flex items-center justify-center px-6">
      <div className="w-full max-w-md">
        <div className="flex items-center gap-2 text-white mb-8 justify-center">
          <Diamond className="w-5 h-5 text-gold fill-[var(--gold)]" />
          <span className="font-extrabold tracking-[0.35em] text-lg">SUPERA</span>
        </div>
        <div className="bg-white rounded-[28px] p-8 shadow-2xl">
          <div className="flex items-center gap-3 mb-6">
            <span className="w-12 h-12 rounded-xl bg-[#0A1C30] flex items-center justify-center">
              <ShieldCheck className="w-6 h-6 text-gold" />
            </span>
            <div>
              <p className="text-xs font-extrabold tracking-[0.2em] text-[#B99B2E]">PANEL</p>
              <h1 className="text-2xl font-extrabold text-[#0A1C30]">Super Administrador</h1>
            </div>
          </div>
          <form onSubmit={submit}>
            <Label className="text-sm font-bold text-[#0A1C30] mb-1.5 block">Email</Label>
            <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="admin@superaleadership.com" />
            <Label className="text-sm font-bold text-[#0A1C30] mb-1.5 block mt-5">Contraseña</Label>
            <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" />
            <button type="submit" disabled={loading} className="mt-7 w-full flex items-center justify-center gap-2 rounded-2xl bg-[var(--gold)] hover:bg-[var(--gold-soft)] text-[#0A1C30] font-extrabold text-lg py-4 transition-colors disabled:opacity-60">
              {loading ? "Entrando..." : "Entrar al panel"} <ArrowRight className="w-5 h-5" />
            </button>
          </form>
        </div>
        <button onClick={() => navigate("/")} className="mt-6 w-full text-center text-white/60 hover:text-white text-sm transition-colors">
          ← Volver al sitio
        </button>
      </div>
    </div>
  );
}
